import { conversationFrameDisplayTitle } from "@/lib/conversation-display";
import { InputTargetRowIcon, type InputTargetRowIconSource } from "./input-target-row-icon";

/** A compact title stands apart from the prediction's lighter ghost text. */
export function StandaloneBarGhostRoute({ route, icon }: {
  route: string;
  icon: InputTargetRowIconSource;
}) {
  const title = route.replace(/^@/, "");
  return (
    <span
      data-testid="standalone-bar-placeholder-chip"
      role="group"
      aria-label={title}
      className="mr-1.5 inline-flex max-w-full items-baseline gap-1 whitespace-nowrap align-baseline font-medium text-secondary"
    >
      <span className="inline-flex h-3 w-3 shrink-0 self-center opacity-40" aria-hidden="true">
        <InputTargetRowIcon row={icon} size={12} />
      </span>
      <span data-standalone-ghost-route className="min-w-0 truncate">{conversationFrameDisplayTitle(title)}</span>
    </span>
  );
}
